module.exports = __webpack_public_path__ + "img/Westgate Station Concepts_Page_2.b59ec21e.jpg";